import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';


import { FuncionarioService } from '@app/services/funcionario.service';
import { Funcionario } from '@app/models/funcionario';

import { TipoDeAcao } from '@app/models/tipo-de-acao.model';
import { TipoDeAcaoService } from '@app/services/tipo-de-acao.service';
import { Area } from '@app/models/area';
import { AreaService } from '@app/services/area.service';
import { log } from 'console';

@Component({
  selector: 'app-tipo-de-acao-form',
  templateUrl: './tipo-de-acao-form.component.html'
})
export class TipoDeAcaoFormComponent implements OnInit {

  titulo: string;
  lstErros: string[];
  tipoDeAcao: TipoDeAcao = new TipoDeAcao();
  lstAreas : Area[] = [];
  aguardandoSolicitacao: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private tipoDeAcaoService: TipoDeAcaoService,
    private areaService: AreaService) { }

  ngOnInit() {
    this.areaService.obterLista("", 1).toPromise()
    .then(data => {
          this.lstAreas = data;
        },
        (erro) => {
          console.error('Erro ao obter a lista de áreas:', erro);
        }
    );
    const id = this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar Tipo de acão' : 'Novo Tipo de ação';
      if (!id) {
        return;
      }

      this.tipoDeAcaoService.obterPorId(id).toPromise().then(
        data => {this.tipoDeAcao = data;
        },
        () => this.router.navigate(['./configuracoes/tipo-de-acao']));
    });
  }

  alterarArea(){
    const areaSelecionada = this.lstAreas.find(area => area.Descricao === this.tipoDeAcao.AreaDescricao);
    this.tipoDeAcao.AreaId = areaSelecionada.Id;
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.tipoDeAcaoService.gravar(this.tipoDeAcao)
      .toPromise().then(
        () => this.router.navigate(['./configuracoes/tipo-de-acao']),
        (data: any) => {
          if (data.error) {
            this.lstErros = data.error.errors;
          }
          this.aguardandoSolicitacao = false;
        });
  }
}
